var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coins"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M17.0001 9.06738V11.6249C17.0001 13.3124 14.2589 14.7046 10.6748 14.9586C11.9789 15.4527 13.6626 15.7499 15.5001 15.7499C19.642 15.7499 23.0001 14.2386 23.0001 12.3749C23.0001 10.7418 20.4239 9.38051 17.0001 9.06738Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.2,
    d: "M9.5 11.25C13.6421 11.25 17 9.73896 17 7.875C17 6.01104 13.6421 4.5 9.5 4.5C5.35786 4.5 2 6.01104 2 7.875C2 9.73896 5.35786 11.25 9.5 11.25Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.5 11.25C13.6421 11.25 17 9.73896 17 7.875C17 6.01104 13.6421 4.5 9.5 4.5C5.35786 4.5 2 6.01104 2 7.875C2 9.73896 5.35786 11.25 9.5 11.25Z",
    fill: "#FFB600",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2 7.875V11.625C2 13.4887 5.35812 15 9.5 15C13.6419 15 17 13.4887 17 11.625V7.875",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.5 10.9688V14.7188",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.0001 9.06738C20.4239 9.38051 23.0001 10.7418 23.0001 12.3749C23.0001 14.2386 19.642 15.7499 15.5001 15.7499C13.6626 15.7499 11.9789 15.4527 10.6748 14.9586",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8 14.9325V16.125C8 17.9887 11.3581 19.5 15.5 19.5C19.6419 19.5 23 17.9887 23 16.125V12.375",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.5 15.4688V19.2188",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.5 10.9688V19.2188",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/Coins.f16ecc2de536135d001eb3c70a2a555a.svg";
export { ForwardRef as ReactComponent };